import { useAbsUrl } from 'hooks/useAbsUrl'
import { ComponentType } from 'react'
import { JsonLd } from 'react-schemaorg'
import { SingleFamilyResidence } from 'schema-dts'

interface Props {
  property: any
}

export const Schema: ComponentType<Props> = ({ property }) => {
  const url = useAbsUrl()

  return (
    <JsonLd<SingleFamilyResidence>
      item={{
        '@context': 'https://schema.org',
        '@type': 'SingleFamilyResidence',
        identifier: property.uuid,
        name: property.name,
        url,
        photo: property.cover?.secureUrl,
        description: property.description,
        numberOfRooms: property.places?.rooms,
        numberOfBathroomsTotal: property.places?.bathrooms,
        yearBuilt: property.measurements?.built,
        address: {
          '@type': 'PostalAddress',
          addressLocality: property.zone.name,
          addressRegion: 'Yucatán',
          addressCountry: 'Mexico',
        },
      }}
    />
  )
}
